import { render } from "./Definition_of_basic_measuresById.vue?vue&type=template&id=47d7062e&scoped=true"
import script from "./Definition_of_basic_measuresById.vue?vue&type=script&lang=js"
export * from "./Definition_of_basic_measuresById.vue?vue&type=script&lang=js"

import "./Definition_of_basic_measuresById.vue?vue&type=style&index=0&id=47d7062e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d7062e"]])

export default __exports__